import { ILightTheme } from "../types/ILightTheme";
import { ColorMode } from "../types/ColorMode";
import { theme } from "./theme";

export const lightTheme: ILightTheme = {
  ...theme,
  mode: ColorMode.Light,
};
